// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"acb82853","839":"90a2a3e4"}[chunkId] + ".chunk.js";
};